require('jquery');

require('./jquery-mobile/jquery.mobile.custom');
require('./jquery-plugins/jquery.color');
require('./jquery-plugins/jquery.cookie');
require('./jquery-plugins/jquery.easing');
require('./jquery-ui/jquery-ui-1.10.3.custom');
require('./custom/center');
require('./custom/enter');
require('./custom/keycode');
require('./custom/within');